import environment from "@/constants/Environment";

const { isAI, ENVIRONMENT } = environment();

export default function startCbbSupportBot() {
  const isFromOutgrow = window.localStorage.getItem("outgrow") === "true";
  if (!isAI || ENVIRONMENT === "development" || isFromOutgrow) return;

  if (ENVIRONMENT === "development") {
    window.cbbSettings = {
      base_url: "http://ai.localhost:3001",
      app_id: "venturepact92-13",
      app_type: "chat",
    };
    // } else if (ENVIRONMENT === "staging") {
    //   window.cbbSettings = {
    //     base_url: "https://liveai.outgrow.chat",
    //     app_id: "yopmail645-63",
    //     app_type: "chat",
    //   };
  } else {
    window.cbbSettings = {
      base_url: "https://venturepact92.chatbotbuilder.net",
      app_id: "venturepact92-13",
      app_type: "chat",
    };
  }

  const script = document.createElement("script");
  script.id = "cbb-support-bot";
  script.defer = true;

  if (ENVIRONMENT === "development") {
    script.src = "http://localhost:8000/embed.js";
    // } else if (ENVIRONMENT === "staging") {
    //   script.src = "https://liveai.outgrow.chat/embed.js";
  } else {
    script.src = "https://live.chatbotbuilder.net/embed.js";
  }

  document.head.appendChild(script);
}

startCbbSupportBot();

declare global {
  interface Window {
    cbbSettings: {
      base_url: string;
      app_id: string;
      app_type: "chat" | "voice" | "chat-voice";
      user_data?: Record<string, string>;
    };
    ChatbotBuilder: {
      start(): void;
      open(): void;
      close(): void;
      setUserData(data: Record<string, string>): void;
      getUserData(): Record<string, string>;
      resetChat(): void;
      sendMessage(message: string, role?: "assistant" | "user"): void;
    };
  }
}
